
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData', 'compStylableClass'],
      ({ compData, compStylableClass }) => {
        return {
          ...{"maxValue":0,"minValue":0,"suffix":"","prefix":"","max":100,"min":0,"alignment":"ltr","stepValue":1,"stepType":"Number","sliderType":"Continuous","label":"WSR Slider"},
          ...compData,
          className: compStylableClass
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  